"use strict";

exports.__esModule = true;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var elements_1 = require("./elements");

var emailRegex = /((([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))/g;
var phoneRegex = /(((?:\+|00)[17](?: |-)?|(?:\+|00)[1-9]\d{0,2}(?: |-)?|(?:\+|00)1-\d{3}(?: |-)?)?(0\d|\([0-9]{3}\)|[1-9]{0,3})(?:((?: |-)[0-9]{2}){4}|((?:[0-9]{2}){4})|((?: |-)[0-9]{3}(?: |-)[0-9]{4})|([0-9]{7})))/g;

var Column = function (_a) {
  var col = _a.col,
      colIndex = _a.colIndex,
      _b = _a.header,
      header = _b === void 0 ? [] : _b;
  var enhancedCol = col.replace(emailRegex, '<a href="mailto: $1">$1</a>').replace(phoneRegex, '<a href="tel: $1">$1</a>');

  if (header.includes('l') && colIndex === 0) {
    return react_1["default"].createElement(elements_1.LeftTh, {
      dangerouslySetInnerHTML: {
        __html: enhancedCol
      }
    });
  }

  return react_1["default"].createElement(elements_1.Td, {
    dangerouslySetInnerHTML: {
      __html: enhancedCol
    }
  });
};

exports["default"] = react_1["default"].memo(Column);